import * as React from "react"

export const LONDON_TZ = "Europe/London"

// Visitor's IANA time zone, resolved only after hydration so SSR and the first
// client render agree (both show pre-formatted London labels from the server).
export function useVisitorTimezone(): string | null {
  const [tz, setTz] = React.useState<string | null>(null)
  React.useEffect(() => {
    try {
      const resolved = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (resolved && resolved !== LONDON_TZ) setTz(resolved)
    } catch {
      // Older browsers: keep showing London times.
    }
  }, [])
  return tz
}

export function timeInZone(iso: string, timeZone: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    hour: "numeric",
    minute: "2-digit",
    hour12: false,
    timeZone,
  }).format(new Date(iso))
}

export function dateTimeInZone(iso: string, timeZone: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "2-digit",
    hour12: false,
    timeZone,
  }).format(new Date(iso))
}
